var map = {
	"./boundaries/comparison-legend/desktop.svg": "591e",
	"./boundaries/comparison/2015/desktop.svg": "5ca3",
	"./boundaries/comparison/2015/desktop_old.svg": "c192",
	"./boundaries/comparison/2015/mobile.svg": "103e",
	"./boundaries/comparison/2015/mobile_old.svg": "fbdd",
	"./boundaries/comparison/2020/base-map.ai": "33e6",
	"./boundaries/comparison/2020/desktop.svg": "7867",
	"./boundaries/comparison/2020/desktop_old.ai": "0e77",
	"./boundaries/comparison/2020/desktop_old.svg": "6826",
	"./boundaries/comparison/2020/mobile.svg": "b37a",
	"./boundaries/comparison/2020/mobile_old.ai": "f6f5",
	"./boundaries/comparison/2020/mobile_old.svg": "623b",
	"./boundaries/details/4-members.svg": "1f17",
	"./boundaries/details/5-members.svg": "0139",
	"./boundaries/details/6-members.svg": "eaea",
	"./boundaries/details/smc.svg": "6d35",
	"./boundaries/ge-icon.svg": "3c7e",
	"./boundaries/ge2020-logo.svg": "b9f7",
	"./boundaries/interactive-map/template-for-interactive-map-4326.ai": "3706",
	"./boundaries/keys-east-west-coast/key-1-2015.svg": "226d",
	"./boundaries/keys-east-west-coast/key-1-2020.svg": "d73d",
	"./boundaries/keys-east-west-coast/key-2-2015.svg": "1b5e",
	"./boundaries/keys-east-west-coast/key-2-2020.svg": "904a",
	"./boundaries/keys-four-new-smc/key-1-2015.svg": "2a21",
	"./boundaries/keys-four-new-smc/key-1-2020.svg": "dec6",
	"./boundaries/keys-four-new-smc/key-2-2015.svg": "e6af",
	"./boundaries/keys-four-new-smc/key-2-2020.svg": "11f9",
	"./boundaries/keys-four-new-smc/key-3-2015.svg": "f2ee",
	"./boundaries/keys-four-new-smc/key-3-2020.svg": "d194",
	"./boundaries/keys-four-new-smc/key-4-2015.svg": "1b24",
	"./boundaries/keys-four-new-smc/key-4-2020.svg": "e223",
	"./boundaries/keys-sengkang/key-1-2015.svg": "aa4e",
	"./boundaries/keys-sengkang/key-1-2020.svg": "392b",
	"./boundaries/keys-six-members/key-amk/ang-mo-kio.ai": "83eb",
	"./boundaries/keys-six-members/key-amk/key-1.svg": "bf82",
	"./boundaries/keys-six-members/key-amk/key-2.svg": "345a",
	"./boundaries/keys-six-members/key-pasir-ris/key-1.svg": "3845",
	"./boundaries/keys-six-members/key-pasir-ris/key-2.svg": "f368",
	"./boundaries/keys-six-members/key-pasir-ris/pasir-ris.ai": "ff09",
	"./boundaries/keys-three-smc/key-1-2015.svg": "009c",
	"./boundaries/keys-three-smc/key-1-2020.svg": "c34f",
	"./boundaries/keys-three-smc/key-2-2015.svg": "3ff5",
	"./boundaries/keys-three-smc/key-2-2020.svg": "6057",
	"./boundaries/keys-three-smc/key-3-2015.svg": "c0ea",
	"./boundaries/keys-three-smc/key-3-2020.svg": "0006",
	"./boundaries/locator-legend/desktop.svg": "8808",
	"./boundaries/logo-elections.svg": "904b",
	"./boundaries/pattern.png": "a44d",
	"./boundaries/zoom-icon.svg": "d0e9",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8453";